<template>
  <div class="roles">
    <card class="m-b">
      <i-button type="primary"
                @click="createRole">{{$t('pages_roles_index_911')}}</i-button>
    </card>
    <card class="m-b">
      <i-table :data="roles"
               :columns="columns">
        <template slot="operation"
                  slot-scope="{row}">
          <i-button @click="edit(row)">{{$t('pages_products_edit_829')}}</i-button>
          <i-button type="error"
                    @click="remove(row)"
                    class="m-l">{{$t('libs_table_render_70')}}</i-button>
        </template>
      </i-table>
    </card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'Roles',
  data () {
    return {
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 100,
        },
        {
          title: i18n.t('pages_roles_index_912'),
          key: 'name'
        },
        {
          width: 200,
          title: i18n.t('pages_ai_image_163'),
          key: 'permission_data',
          slot: 'operation'
        }
      ],
    };
  },
  created () {
    this.clearRecord()
    this.index({ page: 1, per: 10 })
  },
  computed: {
    ...mapState('role', ['role', 'roles', 'meta']),
  },
  methods: {
    ...mapActions('role', ['index', 'create', 'update', 'destroy']),
    ...mapMutations('role', ['clearRecord']),
    edit (row) {
      this.$router.push(`/settings/user_role_permissions/${row.id}`)
    },
    createRole () {
      this.$router.push('/settings/user_role_permissions/new');
    },
    async remove (row) {
      this.$Modal.confirm({
        title: i18n.t('pages_orders_show_705'),
        content: i18n.t('pages_roles_index_913'),
        onOk: async () => {
          await this.destroy(row.id);
          this.index({ page: 1, per: 10 })
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.m-b {
  margin-bottom: 12px;
}
.m-l {
  margin-left: 12px;
}
</style>
